
import { computed, defineComponent, ref } from 'vue'
import { IdfButton, IdfInput } from '@invivodf/ui-kit'

export default defineComponent({
  name: 'SearchBar',
  components: { IdfButton, IdfInput },
  props: {
    disabledByParent: {
      type: Boolean,
      default: false,
    },
    initialQuery: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const query = ref(props.initialQuery)
    const isButtonDisabled = computed(() => {
      return query.value.length < 2
    })
    const handleSearchButtonClick = () => {
      emit('search-click', query.value)
    }
    return { query, handleSearchButtonClick, isButtonDisabled }
  },
  watch: {
    initialQuery: {
      immediate: true,
      handler(newVal) {
        this.query = newVal
      },
    },
  },
})
